import React from "react";

import { ContactTypeForm } from "./ContactTypeForm";
import Text from "../../../../shared/components/Text";

import { theme } from "../../../../styles/theme";
import { useAuth } from "../../../../hooks/useAuth";

const ContactType = () => {
  const { handleSubmitContactType } = useAuth();

  const initialValues = {
    email: "",
    sms: "",
  };

  return (
    <>
      <Text textAlign="center" color={theme.palette.gray.main}>
        Para sua maior segurança, estamos lhe enviando o código de verificação.
        Selecione o contato de sua preferência para enviarmos o código.
      </Text>

      <ContactTypeForm
        initialValues={initialValues}
        onSubmit={handleSubmitContactType}
      />
    </>
  );
};

export default ContactType;
